import { Apollo } from 'apollo-angular';
import { groupBy } from 'lodash';
import { TurbineGroup } from '../services-api-v2/device-groups/device-groups.service';
import { UserPortfoliosWithAllParksAndTurbinesSubscription } from '../services/data-services/graphql';
export interface IParkTurbineData {
  id: string;
  name: string;
  nameLong: string;
  countryCode: string;
  countryName: string;
  displayName: string;
  state: number;
  powerPlantCode: string;
  displayCode: string;
  energyMeterAvailable: boolean;
  groups: TurbineGroup["turbine_groups"];
  turbines: Array<{
    id: string;
    code: string;
    state: number;
    serial: string;
    serialNav: string;
  }>
}

export interface IPortfolioPark {
  id: string;
  name: string;
  displayName: string;
  powerPlantCode: string;
  country?: string;
}

export interface IPortfolioTurbine {
  id: string;
  displayName: string;
  code: string;
  parkName: string;
  powerPlantCode: string;
}

export class NavigationDataModel {
  powerplants: IParkTurbineData[]
  portfolios: Array<{
    name: string,
    id: string,
    defaultPortfolio: boolean,
    // notEditablePortfolio: boolean,
    powerplants: IParkTurbineData[]
  }>
  parksGrouped: boolean;
  selectedPortfolio: { name: string, id: string, powerplants: any, countries?: any }
  navigationFilterOptions?: { options: any[], active: any }

  static mapData(data: Apollo.SubscribeResult<UserPortfoliosWithAllParksAndTurbinesSubscription>, lastSelectedPortfolioId: string, deviceGroupsData: TurbineGroup[]): NavigationDataModel {
    if (data) {
      const parksGrouped = data?.data?.user?.preferences?.parkMenu?.active?.value === 'grouped';
      const allParks = [];
      const portfolios = data?.data?.user?.user_portfolios?.map((a) => {
       const parks = a.parks.sort((x, y) => x.fe_name.localeCompare(y.fe_name)).map(p => {
         const parkModel = NavigationDataModel.mapPark(p,deviceGroupsData?.find(dg => dg._id_park === p._id));
         var index = allParks.findIndex(p2 => p2.id === parkModel.id);
         if (index === -1) {
           allParks.push(parkModel);
         }
         return parkModel;
       });

       return ({
          name: a.name,
          id: a._id,
          defaultPortfolio: a.defaultPortfolio,
          // notEditablePortfolio: null, // a.notEditablePortfolio,
          powerplants: parks,
          countries: groupBy(parks, 'countryName')
        })
      })
      const lastSelectedPortfolio = portfolios?.find(item => item.id === lastSelectedPortfolioId);
      const defaultPortfolio = lastSelectedPortfolio || portfolios?.find(item => item.defaultPortfolio) || portfolios[0];
      const { name, id, powerplants, countries } = defaultPortfolio;
      const { options, active } = data.data.user.preferences?.headerDropdownColorType
      return new NavigationDataModel({
        powerplants: allParks,
        portfolios,
        parksGrouped,
        selectedPortfolio: { name, id, powerplants, countries },
        navigationFilterOptions: { options, active }
      });
    } else {
      return null;
    }
  }

  static mapPark(park, deviceGroupsData: TurbineGroup) {
    return {
      id: park._id,
      name: park.code,
      nameLong: park.name,
      displayName: park.fe_name,
      state: park.data.WTUR1_status.min,
      loadFactor: park.data.WTUR1_per_loadFactor.avg * 100,
      efficiency: park.data.WTUR1_per_efficiency.avg * 100,
      powerPlantCode: park.code,
      displayCode: park.displayCode || park.code,
      countryCode: park.country.code,
      countryName: park.country.name,
      energyMeterAvailable: park.energyMeterAvailable,
      groups: deviceGroupsData?.turbine_groups || [],
      turbines: park.turbines.map(turbine => Object.assign({
        id: turbine._id,
        code: turbine.code,
        codeDisplay: turbine.codeDisplay,
        state: turbine.data?.WTUR1_status || 8,
        loadFactor: turbine.data?.WTUR1_per_loadFactor * 100 || 0,
        efficiency: turbine.data?.WTUR1_per_efficiency * 100 || 0,
        serial: turbine.serial,
        serialNav: turbine.serialNav,
        serialDisplay: turbine.serialDisplay
      }))
    }
  }

  constructor(init: Partial<NavigationDataModel>) {
    Object.assign(this, init);
  }

}
